import { z } from "zod";

export const ZMongoIdStr = z.string().regex(/^[0-9a-fA-F]{24}$/, "Invalid ObjectId");

type ObjectIdLike = { toHexString(): string };
const isObjectIdLike = (value: unknown): value is ObjectIdLike =>
  typeof (value as ObjectIdLike | null)?.toHexString === "function";

export const ZObjectIdString = z
  .union([ZMongoIdStr, z.custom<ObjectIdLike>(isObjectIdLike).transform((value) => value.toHexString())])
  .pipe(ZMongoIdStr);

export const ZGroupEnum = z.enum(["ADMIN", "INTERNAL", "PARTNER", "CLIENT"]);
export type IGroupEnum = z.infer<typeof ZGroupEnum>;

export const ZUserPartial = z.object({
  _id: ZObjectIdString,
  name: z.string(),
});
export type IUserPartial = z.infer<typeof ZUserPartial>;

export const ZAccessLevel = z.enum(["PROJECT", "USERS", "GROUPS"]).describe("AccessLevels");

export const ZAccess = z.object({
  level: ZAccessLevel,
  groups: z.array(ZGroupEnum),
  users: z.array(ZObjectIdString),
});
export type IAccess = z.infer<typeof ZAccess>;

export const ZAccessPopulated = ZAccess.extend({
  users: z.array(ZUserPartial),
});
export type IAccessPopulated = z.infer<typeof ZAccessPopulated>;
